import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const opportunityApplicationService = createApi({
    reducerPath: 'opportunityApplicationService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['OpportunityApplication'],
    endpoints: (builder) => ({

        // ⭐ GET ALL PAGINATED WITH SORTING
        getAllOpportunityApplication: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationController.getAllOpportunityApplication}/${body.page}/${body.size}?orderBy=${body.sort}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        // ⭐ GET BY ID
        getOpportunityApplicationById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationController.getOpportunityApplicationById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        // ⭐ SAVE
        saveOpportunityApplication: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationController.saveOpportunityApplication}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,   // JSON or multipart form-data
                };
            }
        }),

        // ⭐ UPDATE
        updateOpportunityApplication: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationController.updateOpportunityApplication}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            }
        }),

        // ⭐ DELETE
        deleteOpportunityApplication: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationController.deleteOpportunityApplication}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        // ⭐ SEARCH
        getAllOpportunityApplicationBySearch: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationController.getAllOpportunityApplicationBySearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),

        // ⭐ FIND ALL (NO PAGINATION)
        findAllOpportunityApplication: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationController.findAllOpportunityApplication}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        // ⭐ BULK UPLOAD
        bulkSaveOpportunityApplication: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationController.bulkSaveOpportunityApplication}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload, // multipart/form-data or JSON
                };
            }
        }),
        getOpportunityDueDiligence: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationController.getOpportunityDueDiligence}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        downloadReport: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationController.downloadReport}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                    responseHandler: (response) => response.blob(),
                    responseType: 'blob',
                }
            }
        }),
        addToProject: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationController.addToProject}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,   // JSON or multipart form-data
                };
            }
        }),
        addToAudit: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationController.addToAudit}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,   // JSON or multipart form-data
                };
            }
        }),
        addToFinance: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityApplicationController.addToFinance}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,   // JSON or multipart form-data
                };
            }
        }),
    }),
});

export const {
    useGetAllOpportunityApplicationMutation,
    useGetOpportunityApplicationByIdMutation,
    useSaveOpportunityApplicationMutation,
    useUpdateOpportunityApplicationMutation,
    useDeleteOpportunityApplicationMutation,
    useGetAllOpportunityApplicationBySearchMutation,
    useFindAllOpportunityApplicationMutation,
    useBulkSaveOpportunityApplicationMutation,
    useGetOpportunityDueDiligenceMutation,
    useDownloadReportMutation,
    useAddToProjectMutation,
    useAddToAuditMutation,
    useAddToFinanceMutation,
} = opportunityApplicationService;
